const get = state => state.surveyFieldworkOverview;

export const getFieldworkOverviewDataSelector = state => get(state).data;
export const getFieldworkTableScopeSelector = state => get(state).tableScope;
